import Web3 from 'web3';
import { woolTokenABI } from '@/utils/abi';
import BigNumber from 'bignumber.js';
import { EventBus } from '@/utils/EventBus';
import { metaMaskErrorHandler, MetaError } from '@/utils/errorHandler';

export const contractAddress = process.env.VUE_APP_WOOL_TOKEN_CONTRACT_ADDRESS;

let contract: any = null;

export const initContract = () => {
  if (window.web3 && contract === null) {
    contract = new window.web3.eth.Contract(woolTokenABI, contractAddress);
  }
};

export const balanceOf = async (address: string) => {
  initContract();
  if (!address) {
    return;
  }
  try {
    const amount = await contract.methods.balanceOf(address).call();
    return window.web3.utils.fromWei(amount, 'ether');
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};
